// extracted by mini-css-extract-plugin
export var content = "content-module--content--9LjEd";
export var jsAnimInit = "content-module--jsAnimInit--1tdSZ";
export var hero = "content-module--hero--3Cgph";
export var list = "content-module--list--lZPUT";
export var title = "content-module--title--1bQFb";
export var title_markered = "content-module--title_markered--1tApC";